<div class="row justify-content-center">
    <div class="col-auto">
        <div class="section-header mb-4 d-flex text-center justify-content-center gap-2" style="max-width: 520px;">
            <span class="material-symbols-outlined">shield</span>
            <h1 class="h4">Gestión de <strong class="fw-semibold text-colonial">Productos</strong></h1>
        </div>
        <p class="text-muted mx-auto text-center" style="max-width: 520px;">Visualiza, crea, edita y elimina los
            productos.</p>
    </div>
</div>

<div class="row justify-content-center">
    <div class="col-12 col-xl-10">
        <div class="card shadow-sm border-0 overflow-hidden rounded-4">
            <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h3 class="h5 mb-0 d-flex gap-2 align-items-center">
                    <span class="material-symbols-outlined text-colonial">list</span>
                    <span>Productos</span>
                </h3>
                <div class="d-flex align-items-center gap-3">
                    <div *ngIf="showBankFilter" class="d-flex align-items-center gap-2">
                        <label for="bankFilter" class="mb-0 text-muted small">Banco:</label>
                        <select id="bankFilter" class="form-select form-select-sm" style="min-width: 180px;"
                            [(ngModel)]="selectedBankId" (ngModelChange)="onBankFilterChange()">
                            <option [ngValue]="null">Todos</option>
                            <option *ngFor="let bank of banks" [ngValue]="bank.id">{{ bank.name }}</option>
                        </select>
                    </div>
                    <button *ngIf="canManagePlans" (click)="navigateToCreate()"
                        class="btn bg-colonial btn-secondary d-flex align-items-center gap-1" type="button">
                        <span class="material-symbols-outlined" style="font-size: 18px;">add</span>
                        Nuevo
                    </button>
                </div>
            </div>
            <shared-table-container>
                <shared-table [headers]="tableHeaders" [items]="insuranceTypes" searchPlaceholder="Buscar productos"
                    title="Productos" [draggable]="canManagePlans" (itemsReordered)="onReorder($event)">
                    <ng-template let-name="name" let-bankId="bankId" let-visible="visible"
                        let-visibleForBank="visibleForBank" sharedTableColumn="name">
                        <span class="d-inline-flex align-items-center gap-2">
                            {{ name }}
                            <span *ngIf="bankId == null" class="badge rounded-pill text-colonial border"
                                style="border-color: #9A0113 !important; background: #fdf1f2;">Colonial</span>
                            <span *ngIf="visible === false || visibleForBank === false"
                                class="material-symbols-outlined text-muted" style="font-size: 16px;"
                                title="Oculto en la aplicación de clientes">visibility_off</span>
                        </span>
                    </ng-template>
                    <ng-template let-category="category" sharedTableColumn="category">
                        <span>{{ displayCategory(category) }}</span>
                    </ng-template>
                    <ng-template let-familyAllowed="familyAllowed" sharedTableColumn="familyAllowed">
                        <span>{{ displayBoolean(familyAllowed) }}</span>
                    </ng-template>
                    <ng-template let-id="id" let-bankId="bankId" sharedTableColumn="actions">
                        <div *ngIf="canEditProduct(bankId); else readonlyView" class="d-flex gap-2">
                            <button (click)="$event.stopPropagation(); navigateToEdit(id)"
                                class="btn btn-sm btn-outline-secondary" type="button">
                                <span class="material-symbols-outlined" style="font-size: 18px;">edit</span>
                            </button>
                            <button (click)="$event.stopPropagation(); deleteInsuranceType(id)"
                                class="btn btn-sm btn-outline-danger" type="button">
                                <span class="material-symbols-outlined" style="font-size: 18px;">delete</span>
                            </button>
                        </div>
                        <!-- Colonial products (and everything, for regionals) are consulted readonly -->
                        <ng-template #readonlyView>
                            <button *ngIf="canViewReadonly" (click)="$event.stopPropagation(); navigateToEdit(id)"
                                class="btn btn-sm btn-outline-secondary" type="button" title="Ver producto">
                                <span class="material-symbols-outlined" style="font-size: 18px;">visibility</span>
                            </button>
                        </ng-template>
                    </ng-template>
                </shared-table>
            </shared-table-container>
        </div>
    </div>
</div>